import { Helmet } from "react-helmet";
import Breadcrumb from "../components/Breadcrumb";
import classes from "./WarrantyInformation.module.css";
import { Link } from "react-router-dom";

export default function WarrantyInformation() {
  return (
    <>
      <Helmet>
        <title>
          Warranty Information - TechMatter UK Delivery Methods and Timelines
        </title>
        <meta
          name="description"
          content="Explore TechMatter UK's Warranty Information. Learn about delivery times, cut-off schedules, DHL shipping, handling of missing or damaged items, and fast UK-wide delivery for IT products."
        />
        <link
          rel="canonical"
          href="https://techmatter.co.uk/warranty-information"
        />
      </Helmet>

      <Breadcrumb currentPage="Warranty Information" />
      <div className={`container ${classes.warrantyInformationContainer}`}>
        <h2 className={classes.mainHeading}>Price Match Guarantee:</h2>
        <p className={classes.paragraph}>
          TechMatter aims to provide you with the lowest prices possible of the
          product and give a guarantee that our prices will never exceed the
          competitor’s price.
        </p>
        <p className={classes.paragraph}>
          Due to the volatile nature of the marketplace, the prices may vary.
        </p>
        <p className={classes.paragraph}>
          For more accurate pricing please contact your assigned account
          manager.
        </p>
        <p className={classes.paragraph}>
          You may contact our chat support, Call us or leave an email at{" "}
          <Link to="mailto:sales@techmatter.co.uk">
            sales@techmatter.co.uk{" "}
          </Link>
        </p>
        <h3 className={classes.subheading}>Quality Assurance:</h3>
        <p className={classes.paragraph}>
          We prioritize product quality for a better customer experience, and
          therefore, a complete check and balance is done for all the products
          before any shipment. We also make sure that all of our products are
          Original and Genuine. Both our products whether “New Sealed” or
          “Used/Refurbished” are certified for having the best standards.
        </p>{" "}
        <h3 className={classes.subheading}>Money-Back Guarantee:</h3>
        <p className={classes.paragraph}>
          We have an Easy Return Policy, so in case of any inconvenience you can
          Exchange or Return the product ordered from TechMatter
        </p>
        <h3 className={classes.subheading}>Secure Payment & Shipment:</h3>
        <p className={classes.paragraph}>
          Our customers trust us and we value this trust above all. Our
          suppliers ship our items on time and with complete safety, ensuring
          there is a secure payment method in place.
        </p>
        <h3 className={classes.subheading}>
          Return Merchandise Authorization (RMA) Process:
        </h3>
        <p className={classes.paragraph}>
          In case of any returns, an RMA request should be raised after agreeing
          on the given terms and conditions:
        </p>
        <ul className={classes.list}>
          <li>
            {" "}
            It is mandatory on all the returns of Techmatter items regardless of
            the reason for return.
          </li>
          <li>
            Items should be returned with all the accessories, manuals,
            software, and warranty claims. There should be no damage to the
            original packaging.
          </li>
          <li>
            On receiving your RMA number, you will have to repack goods exactly
            as they were delivered to you, perhaps in the original outer
            box/package. A restocking fee of 50% will be charged if the original
            packaging is damaged.
          </li>

          <li>
            To avoid return rejection, do not write directly on the original
            box/package.
          </li>

          <li>
            To avoid return rejection, clearly mention on the outer box the RMA
            number.
          </li>
          <li>
            Using a label, accurately and mention Techmatter’ full address on
            the outer package.
          </li>
          <li>
            Once the shipment has been received and tested by our supply chain
            department, you will receive your exchanged product within 10 days
            of receipt of the damaged item.
          </li>

          <li>
            Please note that in case of any discrepancies between your PO and
            the goods received, we must be informed within 7 days of receipt of
            the product.
          </li>
        </ul>
      </div>
    </>
  );
}
